import templateUrl from './delete.html'
import './delete.scss'


const AccountDeletedModalComponent = {
  bindings: {
    portfolio: '<?',
    onSave: '&?'
  },
  require: {
    modalCtrl: '^^cdblModal'
  },
  templateUrl,
  controller: class AccountDeletedModalComponent {
    constructor ($timeout, EventEmitter, DeleteAccountService, ModalService, Configuration, UserService) {
      'ngInject'
      this._identify = 'AccountDeletedModalComponent'
      this.$timeout = $timeout
      this.EventEmitter = EventEmitter
      this.DeleteAccountService = DeleteAccountService
      this.ModalService = ModalService
      this.Configuration = Configuration
      this.UserService = UserService
    }

    $onInit () {
      this.isSSOUser = !!this.UserService.user.ssoProvider
      if (this.isSSOUser) {
        this.formData = {
          confirmationText: ''
        }
      } else {
        this.formData = {
          email: '',
          current_password: '',
        }
      }
    }

    onChangeField (fieldName, validationRule) {
      this.deleteForm[fieldName].$setValidity(validationRule, true)
    }

    isFormInvalid () {
      if (this.isSSOUser) {
        // For SSO users, check that confirmation text equals "delete" (case insensitive)
        const hasCorrectConfirmation = this.formData.confirmationText &&
          this.formData.confirmationText.toLowerCase() === 'delete'
        return !hasCorrectConfirmation
      } else {
        // For regular users, use standard form validation
        return this.deleteForm.$invalid
      }
    }

    deleteAccount () {
      this.isProcessing = true

      const deletePromise = this.isSSOUser
        ? this.DeleteAccountService.deleteSSOAccount(this.formData)
        : this.DeleteAccountService.deleteAccount(this.formData)

      deletePromise
        .then(response => {
          this.ModalService.clear()
          this.ModalService.close()
          this.ModalService.open({
            closeOnBackdrop: false,
            closeIcon: true,
            layout: 'center',
            class: 'cdbl-account-modal cdbl-delete-account-result-dialog cdbl-modal--style-with-dividers cdbl-modal--style-with-sticky-header-and-footer',
            template: `
              <cdbl-delete-account-result-dialog>
              </cdbl-delete-account-result-dialog>`,
            success: 'Your account was successfully suspended and your personal data will be removed within 30 days.',
            title: 'DELETE YOUR PERSONAL DATA'
          })
        })
        .catch(errors => {
          this.ModalService.clear()
          this.ModalService.close()
          if (this.isSSOUser) {
            if (errors.error === 'incorrectConfirmation') {
              this.deleteForm.confirmationText.$setValidity('incorrectConfirmation', false)
            } else {
              this.showErrorModal(errors)
            }
          } else {
            if (errors.error === 'correctPassword') {
              this.deleteForm.password.$setValidity('correctPassword', false)
            } else if (errors.error === 'correctEmail') {
              this.deleteForm.email.$setValidity('correctEmail', false)
            } else {
              this.showErrorModal(errors)
            }
          }
        })
        .finally(() => {
          this.isProcessing = false
        })
    }

    showErrorModal (errors) {
      let errorMessages = []

      // Handle different error response formats
      if (errors.data && errors.data.errors) {
        // Backend validation errors format: { data: { errors: [...] } }
        errorMessages = errors.data.errors
      } else if (errors.errors) {
        // Direct errors format: { errors: [...] }
        errorMessages = errors.errors
      } else if (errors.data && errors.data.error) {
        // Single error format: { data: { error: "message" } }
        errorMessages = [{ message: errors.data.error }]
      } else if (errors.message) {
        // Simple message format: { message: "error" }
        errorMessages = [{ message: errors.message }]
      } else {
        // Fallback
        errorMessages = [{ message: 'An error occurred while deleting your account' }]
      }

      this.ModalService.open({
        closeOnBackdrop: false,
        closeIcon: true,
        layout: 'center',
        class: 'cdbl-account-modal cdbl-delete-account-result-dialog cdbl-modal--style-with-dividers cdbl-modal--style-with-sticky-header-and-footer',
        template: `
          <cdbl-delete-account-result-dialog>
          </cdbl-delete-account-result-dialog>`,
        errors: errorMessages,
        title: 'DELETE YOUR PERSONAL DATA'
      })
    }

    closeDialog () {
      this.modalCtrl.close()
    }
  }
}

export default AccountDeletedModalComponent
